<ng-container *ngIf="vm$ | async as vm">
  <div class="l_flex l_flex-center">
    <span class="par par--small par--light_a"
    >{{ i18n.Core_SortBy }}
      <button
        df-button
        dfButtonType="clear"
        data-dgat="profile-collection-sorting-307"
        class="color-blue ib guts-p-l-half"
        [attr.aria-label]="i18n.Core_SortBy"
        [dfPopoverTrigger]="sortingPopover"
      >
        {{ (vm.sorting || vm.sortKeys[0]).label }}
        <df-icon icon="chevron-down"></df-icon>
      </button>
    </span>
  </div>
  <df-popover
      #sortingPopover
      [isAppendToBody]="false"
      [isFocusFirstItem]="false"
      placement="bottom-right"
  >
    <div class="guts-p-h-2 guts-p-v-1-half sorting-popover">
      <ul>
        <li
          *ngFor="let sortKey of vm.sortKeys; let last = last"
          data-dgat="profile-collection-sorting-dcb"
          [class.guts-m-b-1]="!last"
        >
          <button
            df-button
            dfButtonType="clear"
            data-dgat="profile-collection-sorting-7d9"
            (click)="setSortKey(sortKey)"
          >
            <span class="par par--small par--light_a font-semibold">{{
                sortKey.label
              }}</span>
          </button>
        </li>
      </ul>
    </div>
  </df-popover>
</ng-container>
